var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Animated, Easing } from 'react-native';
import R from '../../../core-res/R';
class LabelText extends PureComponent {
    constructor(props) {
        super(props);
        const { active, focused, variant } = props;
        let initialInputValue = active || focused ? 1 : 0;
        if (variant === 'STANDARD') {
            initialInputValue = 1;
        }
        this.state = {
            input: new Animated.Value(initialInputValue),
        };
    }
    componentWillReceiveProps(props) {
        const { input } = this.state;
        const { active, focused, variant } = this.props;
        // Animate the label text only when the variant is minimal
        if (variant === 'MINIMAL') {
            if (focused ^ props.focused || active ^ props.active) {
                Animated.timing(input, {
                    toValue: props.active || props.focused ? 1 : 0,
                    duration: R.animation.timing.instant,
                    easing: Easing.inOut(Easing.ease),
                }).start();
            }
        }
    }
    render() {
        const _a = this.props, { children, fontSize, disabled, active, focused, variant, labelTextMarginLeft, theme } = _a, props = __rest(_a, ["children", "fontSize", "disabled", "active", "focused", "variant", "labelTextMarginLeft", "theme"]);
        const { input } = this.state;
        let fontWeight = active || focused ? R.typography.weightMedium : R.typography.weightRegular;
        if (variant === 'STANDARD') {
            fontWeight = R.typography.weightMedium;
        }
        const textStyle = Object.assign({ color: input.interpolate({
                inputRange: [0, 1],
                outputRange: [theme.textMuted, disabled ? theme.textMuted : theme.textPrimary],
            }), paddingVertical: input.interpolate({
                inputRange: [0, 1],
                outputRange: [8, 4],
            }), fontSize: input.interpolate({
                inputRange: [0, 1],
                outputRange: [fontSize, 14],
            }) }, fontWeight, { lineHeight: input.interpolate({
                inputRange: [0, 1],
                outputRange: [24, 16],
            }) });
        const top = input.interpolate({
            inputRange: [0, 1],
            outputRange: [32, 8],
        });
        const containerStyle = {
            position: 'absolute',
            top,
            zIndex: 1,
            marginLeft: input.interpolate({
                inputRange: [0, 1],
                outputRange: [labelTextMarginLeft, 0],
            }),
        };
        return (<Animated.View style={containerStyle}>
        <Animated.Text style={textStyle} {...props}>
          {children}
        </Animated.Text>
      </Animated.View>);
    }
}
LabelText.defaultProps = {
    numberOfLines: 1,
    active: false,
    focused: false,
    errored: false,
};
LabelText.propTypes = Object.assign({}, Animated.Text.propTypes, { active: PropTypes.bool, focused: PropTypes.bool, disabled: PropTypes.bool, fontSize: PropTypes.number.isRequired, labelTextMarginLeft: PropTypes.number.isRequired, variant: PropTypes.oneOf(['MINIMAL', 'STANDARD']).isRequired, theme: PropTypes.object });
export default LabelText;
